// extracted by mini-css-extract-plugin
module.exports = {"patent":"styles_patent__A0q_s","patent__text":"styles_patent__text__aHNXz","patent_inbox":"styles_patent_inbox__Gr0tD"};